import { Beleg, Seite } from '@ebeihilfe/einreichung-old';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButton } from '@angular/material/button';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    selector: 'portal-beleg',
    templateUrl: './beleg.component.html',
    styleUrls: ['./beleg.component.scss'],
    standalone: false
})
export class BelegComponent {
  @Input() public beleg: Beleg;
  @Input() public belegIndex: number;
  @Input() public canRemoveBeleg: boolean;
  @Input() public isMandatory: boolean;
  @Input() public pagesNeeded: number;

  @Output() public readonly addNewSeiteToBeleg = new EventEmitter<void>();
  @Output() public readonly deleteBelegModal = new EventEmitter<void>();
  @Output() public readonly moveBelegToTopEmitter = new EventEmitter<void>();
  @Output() public readonly openModal = new EventEmitter<Seite>();
  @Output() public readonly removeFileFromDocument = new EventEmitter<Seite>();

  private _currentFocusButton: MatButton | null;

  public get hasEnoughPages(): boolean {
    if (this.isMandatory) {
      return this.pagesNeeded !== 0 && this.beleg.seiten.length >= this.pagesNeeded;
    }

    return false;
  }

  public get isFirst(): boolean {
    return this.belegIndex === 0;
  }

  @Input() public set focusMoveUpBtn(_: Record<string, never>) {
    if (!this._currentFocusButton) {
      return;
    }
    this._currentFocusButton._elementRef.nativeElement.focus();
    this._currentFocusButton = null;
  }

  public addSeiteToBeleg(): void {
    this.addNewSeiteToBeleg.emit();
  }

  public deleteMe(event: Event): void {
    event.stopPropagation();
    this.deleteBelegModal.emit();
  }

  public moveToTop(event: Event, btnToFocus: MatButton): void {
    this._currentFocusButton = btnToFocus;
    event.stopPropagation();
    this.moveBelegToTopEmitter.emit();
  }

  public openImage(seite: Seite): void {
    this.openModal.emit(seite);
  }

  public removeFileFromBeleg(seite: Seite): void {
    this.removeFileFromDocument.emit(seite);
  }
}
